import styled from 'styled-components';

const Content = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: relative;
    justify-content: center;
    align-items: center;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
        display: block;
    }

    img:nth-child(2) {
        display: none;
    }

    img:nth-child(1) {
        display: block;
    }

    @media (max-width: 768px) {
        img:nth-child(1) {
            display: none;
        }

        img:nth-child(2) {
            display: block;
        }
    }
`;

export const Styled = {
    Content
};
